import { PermissionTarget } from "../Auth/permissionTargets.js"
import { IMPORT_WIZARD_ASSETS_RETENTION_DAYS } from "./assets.js"

/** Every permission the import of a person's images needs: editing the gallery and the person. */
export const PERSON_IMAGES_IMPORT_PERMISSIONS = [PermissionTarget.MEDIA_IMAGE, PermissionTarget.PERSON] as const

/** How many images a search proposes by default, and the most a search proposes or an import adds at once. */
export const PERSON_IMAGES_DEFAULT_LIMIT = 50
export const PERSON_IMAGES_MAX_LIMIT = 100

const DAY_MS = 24 * 3600 * 1000

/** A report lives as long as the previews it shows. */
export const PERSON_IMAGES_REPORT_RETENTION_DAYS = IMPORT_WIZARD_ASSETS_RETENTION_DAYS
export const PERSON_IMAGES_REPORT_RETENTION_MS = PERSON_IMAGES_REPORT_RETENTION_DAYS * DAY_MS

export const getPersonImagesReportDaysLeft = ({ launchedAt, now = new Date() }: { launchedAt: string; now?: Date }) =>
	Math.max(0, Math.ceil((new Date(launchedAt).getTime() + PERSON_IMAGES_REPORT_RETENTION_MS - now.getTime()) / DAY_MS))
